/**
 * Cognito authentication configuration for AETHER.
 * Values are environment-specific — override via REACT_APP_ env vars for production.
 */

/**
 * Resolves an OAuth redirect URL from an explicit env override, otherwise from
 * the current browser origin. Deriving from origin lets the same build work on
 * localhost and the deployed domain without hardcoding either — Cognito has
 * both callback URLs registered.
 */
function resolveRedirect(envValue: string | undefined, path: string): string {
  if (envValue) return envValue;
  if (typeof window !== 'undefined' && window.location?.origin) {
    return `${window.location.origin}${path}`;
  }
  return `https://aetherbeta-mxo.air.amazon.dev${path}`;
}

export const AUTH_CONFIG = {
  userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || 'us-east-1_SseQ71b4L',
  clientId: process.env.REACT_APP_COGNITO_CLIENT_ID || '2tvrqrr5dvbg4g6pe57c5kv6kh',
  domain:
    process.env.REACT_APP_COGNITO_DOMAIN ||
    'aether-beta-986662115763.auth.us-east-1.amazoncognito.com',
  identityProvider: 'AmazonFederate',
  redirectUri: resolveRedirect(process.env.REACT_APP_REDIRECT_URI, '/callback'),
  logoutUri: resolveRedirect(process.env.REACT_APP_LOGOUT_URI, ''),
  scopes: 'openid+email+profile',
  /**
   * LDAP/Cognito group whose members are granted edit access. Members of this
   * group (as carried in the token's `cognito:groups` claim) can create and
   * edit records; everyone else is read-only.
   */
  editGroup: process.env.REACT_APP_EDIT_GROUP || 'aether-gamma',
  /**
   * LDAP/Cognito group (carried in `cognito:groups`) whose members may manage
   * the note abbreviation list (Add/Edit/Delete). Gated strictly on the claim.
   */
  abbreviationsAdminGroup: process.env.REACT_APP_ABBREVIATIONS_ADMIN_GROUP || 'mxo-l6',
} as const;
